import { Pipe, PipeTransform } from '@angular/core';
import { NavSubItem } from '../../models/nav-sub-item';
import { ProductGroupsNavSubItem } from '../models/product-groups-sub-nav-item';

@Pipe({
  name: 'isProductGroupNavSubItem',
  standalone: false
})
export class IsProductGroupSubNavItemPipe implements PipeTransform {
  transform(value: NavSubItem): boolean {
    return value instanceof ProductGroupsNavSubItem;
  }
}
